<template>
    <validation-observer ref="general_settings_form" class="w-100" v-slot="{ meta, setFieldValue, errors }">
        <div class="d-flex justify-content-between flex-md-row flex-column pt-4">
            <div class="d-flex flex-md-row flex-column mb-2 mr-md-4 w-100">
                <form-input
                    class="user-id-input mr-md-2"
                    :leftIcon="['fas', 'user']"
                    :disabled="true"
                    floatingLabel="User ID"
                    v-model="api.user_id"
                ></form-input>
                <form-input
                    class="company-input"
                    :leftIcon="['fas', 'building']"
                    floatingLabel="Company"
                    v-model="website.title"
                ></form-input>
            </div>
            <validation-provider name="public_email" rules="email" class="w-100">
                <form-input
                    :leftIcon="['fas', 'envelope']"
                    floatingLabel="Email Address"
                    @input="(val) => setFieldValue('public_email', val)"
                    v-model="website.public_email"
                    :error="errors.public_email"
                    class="w-100"
                ></form-input>
            </validation-provider>
        </div>
        <div class="d-flex justify-content-between flex-md-row flex-column">
            <div class="d-flex flex-column align-items-start mr-md-4 mb-2 w-100">
                <span class="mr-2">API (v2) Key: </span>
                <div class="d-flex api-key-wrapper mt-1 mb-1 mr-1">
                    <b-form-input
                        class="api-key-input"
                        label="API (v2) Key"
                        type="text"
                        :value="hideApi ? keyMask : api.api_key_2"
                        :readonly="true"
                    >
                    </b-form-input>

                    <responsive-button
                        variant="primary"
                        @click="hideApi = !hideApi"
                        class="show-api-key"
                        title="Show"
                        :icon="['fas', 'eye']"
                    />

                    <responsive-button
                        variant="primary"
                        @click="copyToClipboard(api.api_key_2)"
                        class="copy-api-key"
                        title="Copy"
                        :icon="['fas', 'copy']"
                    />

                    <b-button
                        @click="$bvModal.show(generateAPIKey2ModalId)"
                        class="user-id-input ml-1 mb-3 mb-md-0"
                        variant="primary"
                        >Generate</b-button
                    >
                </div>
            </div>
            <div class="d-flex flex-md-row flex-column align-items-center mb-2 w-100">
                <form-input
                    class="company-input mr-2"
                    :leftIcon="['fas', 'key']"
                    :disabled="true"
                    v-if="false"
                    label="API (v1 - old) Key:"
                    v-model="api.api_key"
                ></form-input>
                <b-button
                    @click="$bvModal.show(generateAPIKey1ModalId)"
                    class="user-id-input mt-md-3 mb-3 mb-md-0"
                    variant="primary"
                    v-if="false"
                    >Generate</b-button
                >
            </div>
        </div>
        <div class="d-flex justify-content-between flex-md-row flex-column">
            <form-input
                :leftIcon="['fas', 'location-dot']"
                floatingLabel="Address 1"
                v-model="website.address_obj.address1"
                class="w-100 mr-md-4"
            ></form-input>
            <form-input
                :leftIcon="['fas', 'location-dot']"
                floatingLabel="Address 2"
                v-model="website.address_obj.address2"
                class="w-100"
            ></form-input>
        </div>
        <div class="d-flex justify-content-between flex-md-row flex-column">
            <div class="d-flex flex-md-row flex-column w-100 mr-md-4">
                <validation-provider name="country" rules="required" class="company-input">
                    <form-select
                        :leftIcon="['fas', 'location-dot']"
                        floatingLabel="Country"
                        :options="countries"
                        :value="selectedCountry"
                        @change="onChangeCountry"
                        :error="errors.country"
                    ></form-select>
                </validation-provider>
                <form-input
                    :leftIcon="['fas', 'location-dot']"
                    floatingLabel="ZIP"
                    class="zip-input"
                    v-model="website.address_obj.zip"
                    @input="autoFillCity"
                ></form-input>
            </div>
            <span class="w-100 form-tip">Your city and state will be automatically added</span>
        </div>
        <div class="d-flex justify-content-between flex-md-row flex-column">
            <form-input
                :leftIcon="['fas', 'location-dot']"
                floatingLabel="City"
                v-model="website.address_obj.city"
                class="w-100 mr-md-4"
            ></form-input>
            <form-select
                :leftIcon="['fas', 'location-dot']"
                floatingLabel="State"
                :options="states"
                class="w-100"
                :value="selectedState"
                @change="onChangeState"
            ></form-select>
        </div>
        <div class="d-flex justify-content-between flex-md-row flex-column">
            <div v-if="provinces.length > 0" class="w-100 mr-md-4">
                <form-select
                    floating-label="Province"
                    :value="selectedProvince"
                    :left-icon="['fas', 'location-dot']"
                    :options="provinces"
                    @input="onChangeProvince"
                ></form-select>
            </div>
            <div class="w-100"></div>
        </div>
        <div class="d-flex justify-content-between flex-md-row flex-column">
            <validation-provider v-slot="{ handleChange }" name="public_phone" rules="validPhoneNumber" class="w-100">
                <form-phone-number-input
                    class="w-100 mr-md-4"
                    floating-label="Phone"
                    v-model="website.public_phone"
                    :default-country-code="defaultCountryCode"
                    :error="errors.public_phone"
                    @input="
                        (val) => {
                            onChangePhone(val);
                            handleChange(val);
                        }
                    "
                    @validate="onValidatePhone"
                ></form-phone-number-input>
            </validation-provider>
            <form-input
                class="w-100"
                :leftIcon="['fas', 'globe']"
                floatingLabel="Website"
                v-model="website.public_website"
            ></form-input>
        </div>
        <div class="d-flex justify-content-between flex-md-row flex-column">
            <div v-if="website.logo_url" class="mb-2 mr-md-4 w-100">
                <div class="thumbnail">
                    <span class="delete-icon" @click="$bvModal.show(deleteLogoModalId)">
                        <font-awesome-icon
                        :icon="['fas', 'xmark']"
                    />
                    </span>
                   
                    <img class="logo" :src="website.logo_url" />
                </div>
            </div>
            <form-file
                v-else
                placeholder="Upload logo..."
                accept="image/*"
                v-model="logo"
                class="mb-2 w-100 mr-md-4"
            ></form-file>
            <div class="w-100"></div>
        </div>
        <b-button class="save-button mb-3" @click="saveSettings" variant="primary" :disabled="!meta.valid"
            >Save</b-button
        >
        <modal :id="deleteLogoModalId" title="Delete Logo" @ok.prevent="deleteLogo"
            >Deleting your logo will remove it from anywhere where its referenced. Are you sure?</modal
        >
        <modal :id="generateAPIKey1ModalId" title="Generate API Key" @ok.prevent="generateAPIKey(1)"
            >Are you sure you want to generate a new key? The old key will no longer be valid.
        </modal>
        <modal :id="generateAPIKey2ModalId" title="Generate API Key" @ok.prevent="generateAPIKey(2)"
            >Are you sure you want to generate a new key? The old key will no longer be valid.
        </modal>
    </validation-observer>
</template>

<script>
    import API from '../../api';
    import debounce from 'lodash/debounce';
    import FormFile from '../generic/form-file/form-file.vue';
    import FormInput from '../generic/form-input/form-input.vue';
    import FormSelect from '../generic/form-select/form-select.vue';
    import page from '../generic/page/page.vue';
    import {
        ACCOUNT_AUTOFILL_VIA_ZIP_ENDPOINT,
        ISETTINGS_UPLOAD_LOGO,
        ISETTINGS_DELETE_LOGO,
        ISETTINGS_GENERATE_API_KEY_V1,
        ISETTINGS_GENERATE_API_KEY_V2,
        ISETTINGS_DATA,
    } from '../../endpoints';
    import Modal from '../generic/modal/modal.vue';
    import { removeScrollMixin } from '../../mixins/remove-scroll-mixin';
    import { mapGetters } from 'vuex';
    import { defineAsyncComponent } from 'vue';
    import responsiveButton from '../generic/responsive-button/responsive-button.vue';

    const FormPhoneNumberInput = defineAsyncComponent(() =>
        import(
            /* webpackChunkName: "lx-form-phone-number-input" */
            '../generic/form-phone-number-input/form-phone-number-input.vue'
        )
    );

    export default {
        components: { page, FormInput, FormSelect, FormFile, Modal, FormPhoneNumberInput, responsiveButton },
        mixins: [removeScrollMixin],
        data() {
            return {
                busy: false,
                tabs: [
                    {
                        title: 'General',
                        route: '/app/isettings/general',
                        active: true,
                    },
                    {
                        title: 'Bookings',
                        route: '/app/isettings/bookings',
                        active: false,
                    },
                    {
                        title: 'Localization',
                        route: '/app/isettings/localization',
                        active: false,
                    },
                    {
                        title: 'Marketing',
                        route: '/app/isettings/marketing',
                        active: false,
                    },
                ],
                logo: null,
                deleteLogoModalId: 'deleteLogoModalId',
                generateAPIKey1ModalId: 'generateAPIKey1ModalId',
                generateAPIKey2ModalId: 'generateAPIKey2ModalId',
                hideApi: true,
                keyMask: '●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●',
            };
        },
        computed: {
            ...mapGetters('iSettings', [
                'website',
                'api',
                'countries',
                'states',
                'provinces',
                'selectedCountry',
                'selectedState',
                'selectedProvince',
            ]),
            defaultCountryCode() {
                return this.countries.find((item) => item.value === this.selectedCountry)?.code;
            },
        },
        mounted() {
            this.$refs.general_settings_form.setValues({
                country: this.selectedCountry,
                email: this.website.public_email,
                public_phone: this.website.public_phone,
            });
        },
        methods: {
            autoFillCity: debounce(async function (value) {
                if (value) {
                    try {
                        this.busy = true;
                        const response = await API.get(ACCOUNT_AUTOFILL_VIA_ZIP_ENDPOINT(this.selectedCountry, value));
                        if (response.data.city) {
                            const website = JSON.parse(JSON.stringify(this.website));
                            website.address_obj.city = response.data.city;
                            this.$store.commit('iSettings/setWebsite', website);
                            this.$store.commit(
                                'iSettings/setSelectedState',
                                this.states.find((item) => item.text === response.data.state).value
                            );
                        } else {
                            this.errorToast({
                                text: 'Unable to auto fill city and state',
                            });
                        }
                    } catch (e) {
                        this.errorToast({ text: 'Could not load state and city' });
                    } finally {
                        this.busy = false;
                    }
                }
            }, 1000),
            async deleteLogo() {
                try {
                    const request = await API.post(ISETTINGS_DELETE_LOGO());
                    this.successToast({ text: 'Logo successfully deleted' });
                    const website = JSON.parse(JSON.stringify(this.website));
                    website.logo_url = request.data.logo_url;
                    this.$store.commit('iSettings/setWebsite', website);
                    this.$bvModal.hide(this.deleteLogoModalId);
                } catch (e) {
                    console.log(e);
                    this.errorToast({ text: 'Could not delete logo' });
                }
            },

            async generateAPIKey(version) {
                try {
                    const request = await API.get(
                        version === 1 ? ISETTINGS_GENERATE_API_KEY_V1() : ISETTINGS_GENERATE_API_KEY_V2()
                    );
                    this.successToast({
                        text: 'New API Key successfully generated.',
                    });
                    this.$store.commit('iSettings/setApi', request.data);
                    this.$bvModal.hide(version === 1 ? this.generateAPIKey1ModalId : this.generateAPIKey2ModalId);
                } catch (e) {
                    this.errorToast({ text: 'Could not generate API Key' });
                }
            },
            async fetchProvinces() {
                try {
                    const data = this.$store.dispatch('iSettings/fetchProvinces', this.selectedState);
                    return data;
                } catch (e) {
                    this.errorToast({ text: 'Could not fetch states' });
                }
            },
            async fetchStates() {
                try {
                    const data = this.$store.dispatch('iSettings/fetchStates', this.selectedCountry);
                    return data;
                } catch (e) {
                    this.errorToast({ text: 'Could not fetch states' });
                }
            },
            async onChangeCountry(value) {
                this.$refs.general_settings_form.setFieldValue('country', value);
                this.$store.commit('iSettings/setSelectedCountry', value);
                const data = await this.fetchStates();
                this.$store.commit('iSettings/setSelectedState', data[0].value);
                await this.fetchProvinces();
            },
            async onChangeState(value) {
                this.$store.commit('iSettings/setSelectedState', value);
                const data = await this.fetchProvinces();
                if (data.length) {
                    this.$store.commit('iSettings/setSelectedProvince', data[0].value);
                }
            },
            async copyToClipboard(value) {
                try {
                    await navigator.clipboard.writeText(value);
                    this.successToast({
                        text: 'Copied to clipboard successfully.',
                    });
                } catch (err) {
                    this.errorToast({
                        text: 'Something went wrong while copying to clipboard.',
                    });
                }
            },
            onChangeProvince(value) {
                this.$store.commit('iSettings/setSelectedProvince', value);
            },

            readAsDataURL(file) {
                return new Promise((resolve, reject) => {
                    const fr = new FileReader();
                    fr.onerror = reject;
                    fr.onload = function () {
                        resolve(fr.result);
                    };
                    fr.readAsDataURL(file);
                });
            },
            async uploadLogo() {
                const data = await this.readAsDataURL(this.logo);
                const formData = {
                    name: this.logo.name,
                    lastModified: this.logo.lastModified,
                    lastModifiedDate: this.logo?.lastModifiedDate?.toString(),
                    size: this.logo.size,
                    type: this.logo.type,
                    data,
                };
                try {
                    const request = await API.post(ISETTINGS_UPLOAD_LOGO(), {
                        logo_file_model: formData,
                    });
                    const website = JSON.parse(JSON.stringify(this.website));
                    website.logo_url = request.data.logo_url;
                    this.$store.commit('iSettings/setWebsite', website);
                    this.successToast({ text: 'Logo successfully uploaded' });
                } catch (e) {
                    this.errorToast({ text: 'Could not upload logo' });
                }
            },
            async saveSettings() {
                try {
                    this.$parent.$emit('busy', true);
                    const currentState = this.states.find((item) => item.value === this.selectedState);
                    const currentCountry = this.countries.find((item) => item.value === this.selectedCountry);
                    const currentProvince = this.provinces.find((item) => item.value === this.selectedProvince);
                    const { data } = await API.post(ISETTINGS_DATA(), {
                        ...this.website,
                        address_obj: {
                            ...this.website.address_obj,
                            country: currentCountry
                                ? {
                                      id: currentCountry.id,
                                      name: currentCountry.text,
                                      code: currentCountry.code,
                                  }
                                : null,
                            province: currentProvince
                                ? {
                                      id: currentProvince.value,
                                      name: currentProvince.text,
                                      code: currentProvince.code,
                                  }
                                : null,
                            state: {
                                id: currentState.value,
                                name: currentState.text,
                                code: currentState.code,
                            },
                        },
                    });
                    if (data.status === 'FAIL') {
                        const countryError = data.errors ? data.errors.address_obj?.country : null;
                        if (countryError) {
                            this.$refs.general_settings_form.setErrors({
                                country: countryError[0],
                            });
                        }
                    } else {
                        this.successToast({
                            text: 'General settings successfully updated',
                        });
                    }
                } catch (e) {
                    this.errorToast({ text: 'Could not update general settings' });
                } finally {
                    this.$parent.$emit('busy', false);
                }
            },
            onChangePhone(value, isValid) {
                this.website.public_phone = value;
            },
            onValidatePhone(value) {
                if (value.valid) {
                    this.website.public_phone = value.number;
                }
            },
        },
        watch: {
            logo() {
                if (this.logo) {
                    this.uploadLogo();
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '~bootstrap/scss/_functions.scss';
    @import '~bootstrap/scss/_variables.scss';
    @import '~bootstrap/scss/mixins/_breakpoints.scss';

    .api-key-wrapper {
        width: 100%;

        .api-key-input {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
        }

        .copy-api-key {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            margin-right: 0 !important;
        }

        .show-api-key {
            border-radius: 0;
            margin-right: 0 !important;
        }
    }
    
    @include media-breakpoint-down(md) {
        .api-key-wrapper {
            max-width: 100%;

            .copy-api-key {
                max-height: 2.35rem;
            }

            .show-api-key {
                max-height: 2.35rem;
            }
        }
    }
</style>

